module.exports = __webpack_public_path__ + "img/check-to-slot.9e2b344b.svg";